import { BreadCrumbsSteps } from "types/common";
import { CancelReason } from "types/subscriptionAndPlans";

export const initialCancelReasons: CancelReason[] = [
  {
    id: 0,
    title: "It’s too expensive",
    checked: false,
    value: "too_expensive",
    display: true,
  },
  {
    id: 1,
    title: "I need more features",
    checked: false,
    value: "need_more_features",
    display: true,
  },
  {
    id: 2,
    title: "I found an alternative",
    checked: false,
    value: "found_alternative",
    display: true,
  },
  {
    id: 3,
    title: "I no longer need it",
    checked: false,
    value: "no_need",
    display: true,
  },
  {
    id: 4,
    title: "Customer service was less than expected",
    checked: false,
    value: "customer_services_issues",
    display: true,
  },
  {
    id: 5,
    title: "Ease of use was less than expected",
    checked: false,
    value: "not_easy_to_use",
    display: true,
  },
  {
    id: 6,
    title: "Quality was less than expected",
    checked: false,
    value: "quality_issue",
    display: true,
  },
  {
    id: 7,
    title: "Other reason",
    checked: false,
    value: "other_reason",
    display: true,
  },
];

export const CancelSubscriptionSteps: BreadCrumbsSteps[] = [
  { id: 0, title: "Subscriptions & Plans" },
  { id: 1, title: "Cancel plan" },
  { id: 2, title: "Confirm" },
];
